import initLandingFilter from '../modules/landingFilter.js';
import initSliderDetailsPanel from '../modules/tours.js';
import initToursLanding from '../modules/tours-landing.js';
import initExhibitions from '../modules/exhibitions.js';
import initResources from '../modules/resources.js';
import initResourcesSliders from '../modules/resources-sliders.js';
import initAddExhibition from '../modules/add-your-exhibition.js';
import initNews from '../modules/news.js';
import initPage from '../modules/page.js';
import initFavourites from '../modules/favourites.js';
import initHomeSliderCaptions from '../modules/home-slider-captions.js';
import initAccessibilityWidget from '../modules/accessibility-widget.js';
import initTouringStandards from '../modules/touring-standards.js';


(function(){
  // Safe jQuery reference if loaded by theme

  const $ = window.jQuery || null;
  let hasInitialised = false;

  function initialise() {
    if (hasInitialised) {
      return;
    }

    hasInitialised = true;

    initLandingFilter($);

    initSliderDetailsPanel($);

    // Captures the visible tour IDs on the tours landing page and
    // POSTs them to nets_set_tour_results so prev/next on single-tour
    // pages knows which tour comes next in the user's filter context.
    initToursLanding($);

    initExhibitions($);

    initResources($);

    initResourcesSliders();

    initAddExhibition($);

    initNews($);

    initPage($);

    initFavourites($);

    initHomeSliderCaptions();
    initAccessibilityWidget();
    initTouringStandards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }

})();
